<script setup lang="ts">
import { ContextInput, KindType } from '@/__generated__/gateway/graphql';
import { useCommunityTranslations } from '@/shared/composables/community/translations';
import {
  getEntityFromContext,
  getEntityIdFromContext,
  getLanguageFromContext
} from '@/shared/utils/gateway/context';

import PostList from '../PostList.vue';

const context: ContextInput = {
  entity: getEntityFromContext(),
  entity_id: getEntityIdFromContext(),
  kind: KindType.Qa,
  language: getLanguageFromContext()
};

const communityTranslations = useCommunityTranslations('Q&A');

if (!context.entity) {
  throw new Error('Missing entity.');
}
if (!context.entity_id) {
  throw new Error('Missing entity_id.');
}
</script>

<template>
  <div class="mx-auto mt-5 max-w-2xl">
    <PostList
      :context="context"
      :show-teasers="false"
      :community-translations="communityTranslations"
    />
  </div>
</template>
